import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import {
    callSuggestionsReducer,
    debug,
    lowCallVolumeReminderReducer,
    promptReducer,
    sales,
    trainer,
    transcriptReducer,
    userReducer
} from './ui';
import { backgroundReducer } from './backend';

const trainerPersistConfig = {
    key: 'trainer',
    storage,
    whitelist: ['lastCallPhraseSpottingScore', 'isLastCallResult', 'isCallResultVisible', 'systemSoundRecognition']
};

const transcriptPersistConfig = {
    key: 'transcript',
    storage,
    whitelist: ['isVisible', 'timelineTranscripts']
};

const debugPersistConfig = {
    key: '_debug',
    storage,
    whitelist: ['callIds']
};

const promptPersistConfig = {
    key: 'prompt',
    storage,
    whitelist: ['config', 'lastUpdated', 'currentPrompt', 'calls', 'languageCode']
};

const userPersistConfig = {
    key: 'user',
    storage,
    whitelist: ['agencyId', 'locationId', 'companyId', 'userId']
};

const callSuggestionsConfig = {
    key: 'suggestions',
    storage,
    whitelist: [
        'callsAfterLastRequest',
        'callSuggestionsOpen',
        'isCallSuggestionsNew',
        'suggestionsTimestamp',
        'languageCode',
        'suggestions'
    ]
};

const baseReducers = combineReducers({
    user: persistReducer(userPersistConfig, userReducer),
    sales,
    prompt: persistReducer(promptPersistConfig, promptReducer),
    callSuggestions: persistReducer(callSuggestionsConfig, callSuggestionsReducer),
    lowCallVolumeReminder: lowCallVolumeReminderReducer,
    trainer: persistReducer(trainerPersistConfig, trainer),
    transcript: persistReducer(transcriptPersistConfig, transcriptReducer),
    _debug: persistReducer(debugPersistConfig, debug),
    backend: backgroundReducer
});

export default baseReducers;
